<template>
    <div>dashboard.vue</div>
</template>

<script>
    export default {
        name: 'DrivingSchoolDashboard',
        data() {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/DrivingSchool/Dashboard/Dashboard.vue